<div class="dialog-container">
  <div class="header">
    <div class="title">
      <p>Add the Add-on service without it’s primary service?</p>
    </div>
    <div class="text-right">
      <i id="canned-service-dialog-close" class="fal fa-times pointer ml-4 mr-2" (click)="handleClose()"></i>
    </div>
  </div>
  <div class="body-msg">
    <p>The time for {{addOnName}} is an add-on to a {{primaryServiceName}}. Are you sure you want to proceed without adding the primary service?</p>
  </div>
  <div class="footer">
    <div class="cncl-btn" (click)="handleClose()">Cancel</div>
    <div class="done-btn" (click)="handleConfirm()">Confirm</div>
  </div>
</div>